// Customers index
import mutations from './mutations';
import actions from './actions';
import getters from './getters';

export default {
  state: {
    adminReports: {
      items: [],
      count: '',
      entity: {},
    },
  },
  actions,
  mutations,
  getters,
};
